<split-steps #steps (stepChange)="changeTitle($event)">
  <split-step [passo]="0">
    <div class="grid m-0 mb-7" >
      <div class="col-5 mb-4">
        <split-search></split-search>
      </div>

      <div class="col-12 p-0">
        <div *ngFor="let servico of servicos">
          <split-line-with-button
            [title]="servico.name"
            [selected]="seviceSelected && seviceSelected.id === servico.id"
            (select)="selectService(servico)"
          >
          </split-line-with-button>
        </div>
      </div>
    </div>
  </split-step>

  <split-step [passo]="1">
    <form class="mb-7" [formGroup]="form">
      <div class="grid p-fluid">
        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              appendTo="body"
              [options]="(professionals$ | async)!"
              [autoDisplayFirst]="false"
              optionLabel="name"
              inputId="float-label"
              formControlName="employee"
            >
            </p-dropdown>
            <label
              class="text-xs pl-1 h-1rem flex align-items-center text-sm"
              for="float-label"
            >
              Profissional
            </label>
          </span>
        </div>

        <div class="col-6">
          <span class="p-float-label">
            <p-dropdown
              appendTo="body"
              [options]="deliveryTime"
              [autoDisplayFirst]="false"
              optionLabel="nome"
              optionValue="nome"
              inputId="float-label"
              formControlName="deliveryTime"
            >
            </p-dropdown>
            <label
              class="text-xs pl-1 h-1rem flex align-items-center text-sm"
              for="float-label"
            >
              Tempo de entrega
            </label>
          </span>
        </div>
      </div>
    </form>
  </split-step>

  <ng-template #customNextButton *ngIf="steps.activeIndex == 1">
    <div class="col-12 px-0 text-right">
      <p-button [disabled]="form.invalid" (onClick)="saveForm()" class="ml-4" label="Salvar"></p-button>
    </div>
  </ng-template>
  <ng-template #customNextButton *ngIf="steps.activeIndex == 0"> </ng-template>
  <ng-template #customPreviousButton *ngIf="steps.activeIndex == 0">
  </ng-template>
</split-steps>
